<template>
  <h3
    v-show="showHeader"
    :class="$style.header"
  >
    {{ headerLabel }}
  </h3>
</template>
<script>
import {
  ItemActionConsts, ItemTypeConsts, StoreModelMap, StoreModuleMap,
} from 'client/util/Constants';
import { extend, values } from 'lodash';
import { mapGetters } from 'vuex';

const { create, update } = ItemActionConsts;

const itemTypeValidator = value => values(ItemTypeConsts).indexOf(value) !== -1;

export default {
  name: 'AsidePanelBodyContentHeader',

  props: {
    childItemType: {
      required: true,
      type: String,
      validator: itemTypeValidator,
    },
    headerLabels: {
      required: true,
      type: Object,
      validator: function validator(value) {
        if (!value) {
          return false;
        }

        if (!value[create] || !value[update]) {
          return false;
        }

        const { useDisplayName } = value;

        if (typeof useDisplayName !== 'undefined' && typeof useDisplayName !== 'boolean') {
          return false;
        }

        return true;
      },
    },
    parentItemType: {
      required: true,
      type: String,
      validator: itemTypeValidator,
    },
  },

  computed: {
    hasStoreModel() {
      return !!StoreModelMap[this.parentItemType];
    },

    headerLabel() {
      let headerLabel;

      if (this.hasStoreModel) {
        if (this.isItemBeingCreated) {
          headerLabel = this.headerLabels.create;
        } else if (this.isItemBeingUpdated && this.headerLabels.useDisplayName === false) {
          headerLabel = this.headerLabels.update;
        } else if (this.isItemBeingUpdated) {
          headerLabel = `${this.displayName} ${this.headerLabels.update}`;
        }
      }

      return headerLabel ? `${headerLabel}:` : '';
    },

    showHeader() {
      if (typeof this.totalCountOfAllItems === 'number' && this.totalCountOfAllItems === 0) {
        return false;
      }

      return true;
    },
  },

  /**
   * Extend the computed properties and methods here, before the component is
   * created so that the namespace argument to mapActions() and mapGetters()
   * can be set dynamically from the props passed to the AsidePanel component.
   * @see https://github.com/vuejs/vuex/issues/863#issuecomment-315619012
   */
  beforeCreate() {
    const storeModel = StoreModelMap[this.$options.propsData.parentItemType];

    if (storeModel) {
      extend(
        this.$options.computed,
        mapGetters(storeModel, [
          'displayName',
          'isItemBeingCreated',
          'isItemBeingUpdated',
        ]),
      );
    }

    const childStoreCollection = StoreModuleMap[this.$options.propsData.childItemType];

    if (childStoreCollection) {
      extend(
        this.$options.computed,
        mapGetters(childStoreCollection, {
          totalCountOfAllItems: 'getTotalCountOfAllItems',
        }),
      );
    }
  },
};
</script>
<style module>
@value (gradientDark2) from '~css/colors.css';

.header {
  color: gradientDark2 !important;
  font-size: 1.1rem !important;
  font-weight: 700 !important;
  margin: 0 !important;
  padding: 10px 20px 3px !important;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
